import { TextField, Typography } from "@mui/material";

import { useAppContext } from "../../../../../../2_ksbHub/context/appContext";

export default function BszTeacherSearch({ hasTeachers, query, onChange }) {
  const { isMobile } = useAppContext();

  if (!hasTeachers) {
    return (
      <Typography sx={{ opacity: 0.6 }}>
        {isMobile ? "❌ Noch niemand da" : "❌ Noch keine Lehrperson anwesend"}
      </Typography>
    );
  }

  return (
    <TextField
      size="small"
      placeholder="Fach suchen…"
      value={query}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
